import React from "react";
import { withRouter } from "react-router-dom";

import {
  OverlayTrigger,
  Popover,
  Tabs,
  Tab,
  Badge,
  Button,
  ButtonGroup,
  ProgressBar,
  DropdownButton,
  MenuItem
} from "react-bootstrap";
import Select from "react-select";

import styles from "./style.module.css";

import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faTimesCircle,
  faChartBar,
  faBullseye,
  faCog,
  faFileExport,
  faLock,
  faDatabase
} from "@fortawesome/free-solid-svg-icons";

import ModelsIconBlack from "images/modelsBlack.svg";
import ModelsIconWhite from "images/modelsWhite.svg";
import CogIcon from "images/cog-light.svg";
import LockedIcon from "images/lock-alt-light.svg";
import UnlockedIcon from "images/lock-open-alt-light.svg";
import ExportIcon from "images/file-import.svg";
import DatabaseIcon from "images/database-light.svg";
import BullseyeIcon from "images/bullseye-light.svg";

import BullseyeBlue from "images/bullseye-arrow-light-blue.svg";
import AcademicBlue from "images/academic-blu.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import ModelGroupHeader from "components/OldProject/ModelGroupHeader";
import BreadCrumb from "components/BreadCrumbs/BreadCrumb";

import { INITIAL_BLUEPRINTS } from "containers/Wizard/reducer";
import { PROJECT_MODES } from "containers/Run/reducer";
import MarketplaceContainer from "containers/CreateWizard/Marketplace/Marketplace";

import RunItem from "containers/View/Item/RunItem";

import { isEnabled } from "utils/featureFlags";

import { select } from "redux-saga/effects";

export default class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isPublish: false };
  }

  renderInfo() {
    const { dataset, label, updateLabel, successPct, step, success, updateDescription, isSetup } = this.props;

    return (
      <div className={styles.datasetNoHover} style={dataset === undefined ? { justifyContent: "center" } : {}}>
        <div className={styles.topMessage} title={label} style={{ marginBottom: isSetup ? undefined : "6px" }}>
          <LineInput
            isShowEditable={isSetup}
            isLocked={!isSetup}
            isEditable={isSetup}
            value={label}
            showRight
            onChange={(val) => updateLabel(val)}
          />
        </div>
        {dataset ? (
          <React.Fragment>
            <div className={styles.bHolder}>
              <div className={styles.dataIcon}>
                <img src={DatabaseIcon} className={styles.leftIcon} />
              </div>
              <span className={styles.bHolderFont}>{dataset.label}</span>
              <span
                className={styles.botDate}
                title={moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(dataset.created).local().fromNow()}
              </span>
            </div>
            <div className={styles.bHolder}>
              <div className={styles.botMessage}>
                <div className={styles.outcomeIcon}>
                  <img src={BullseyeIcon} className={styles.leftIcon} />
                </div>
                <div className={styles.botInfo + " " + styles.bHolderFont}>
                  {dataset.outcome + (success && success.value ? " (" + success.value + ") occurs " + successPct : "")}
                </div>
              </div>
              {/*
								<div className={styles.botMessage}>
									<div className={styles.botMsg}>{"Columns:"}</div>
									<div className={styles.botInfo}>
										{dataset.fields
											? Object.keys(dataset.fields).length
											: 0}
									</div>
								</div>

								<div className={styles.botMessage}>
									<div className={styles.botMsg}>{"Rows:"}</div>
									<div className={styles.botInfo}>{dataset.rowCount}</div>
								</div>
								*/}
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }

  renderBar(startMessage, endMessasge, progress, hide) {
    return (
      <div className={styles.progressHolder} style={{ display: hide ? "none" : "block" }}>
        <div className={styles.startMessage}>{startMessage}</div>
        <ProgressBar now={progress ? Number(progress) : progress} />
        <div className={styles.endMessage} style={progress < 30 ? { color: "#337ab7" } : {}}>
          {endMessasge}
        </div>
      </div>
    );
  }

  renderProgressBars() {
    const { runId, serverProgress, runCost, isRunning, blueprintId, notebookProgress } = this.props;

    const runCostCurr = isNaN(runCost) ? "Calculating" : "$" + runCost.toFixed(2);

    return (
      <div className={styles.barHolder}>
        <div className={styles.pHolder}>
          {/*
					{this.renderBar(
						"Starting AWS Servers",
						serverProgress >= 100 ? "Server Started" : "",
						serverProgress,
						!isRunning
					)}
					{this.renderBar(
						"Starting Notebooks",
						notebookProgress >= 100 ? "Notebooks Created" : "",
						notebookProgress,
						!isRunning
					)}
					{isRunning && (
						<LoadingIndicator
							style={{
								margin: "0px"
							}}
						/>
					)}
					*/}
        </div>
      </div>
    );
  }

  render() {
    const {
      dataset,
      runId,
      blueprintId,
      blueprint,
      isAdvanced,
      isRunning,
      stat,
      linkedModels,
      modelGroup,
      createModelGroup,
      deleteModelGroup,
      linkModelToGroup,
      updatePriority,
      updateBlueprint,
      createNewBlueprint,
      setupChanged,
      specialOptions,
      reloadBlueprint,
      handleCancel,
      isAibleBlueprint,
      initJob,
      title,
      isEditing,
      relatedJobs,
      updateRelatedId,
      splitColumn,
      hasSplit,
      specialIndex,
      originalId,
      createSetupFromSplit,
      createSetupFromSpecial,
      updateSpecialIndex,
      updateIsEditing,
      lockBlueprint,
      isBlueprintLocked,
      isCreateNewBlueprint,
      modelGroupDeploy,
      canLockBlueprint,
      isAzure,
      mode,
      steps,
      isModelSplits,
      aibleMode,
      isDataMode,
      selectedFolder
    } = this.props;

    const { isPublish, isExport } = this.state;

    const hasSecondHeader = true || runId !== "new";

    // Hardcoded blueprint fun - disable edit blueprint until initial dataset selected
    const disableEdit = INITIAL_BLUEPRINTS[blueprintId] !== undefined && steps.length === 1;

    const aibleImageType = { aibleMode }.aibleMode == "academic" ? AcademicBlue : BullseyeBlue;
    const aibleImageStyleType = { aibleMode }.aibleMode == "academic" ? styles.academic : "";

    return (
      <div className={styles.oHeader}>
        {isPublish && (
          <MarketplaceContainer onHide={() => this.setState({ isPublish: false })} blueprintId={blueprintId} />
        )}
        <div
          className={styles.header + " " + (!isAdvanced ? styles.newHeader : "")}
          style={hasSecondHeader === false ? { borderBottom: "1px solid rgba(0, 0, 0, 0.2)" } : { boxShadow: "none" }}
        >
          {/* <div className={styles.imgContainer + " " + aibleImageStyleType}>
						<img src={aibleImageType} />
					</div> */}
          <div className={styles.dHolder}>
            <BreadCrumb route={"/"}>
              <div className={styles.topMessage}>
                {selectedFolder && selectedFolder.name ? selectedFolder.name : isDataMode ? "Datasets" : "Aible"}
              </div>
            </BreadCrumb>
            {this.renderInfo()}
          </div>
          <div className={styles.run}>
            {!isAzure && !isEditing && this.renderProgressBars()}
            <ModelGroupHeader
              {...this.props}
              {...this.state}
              showPublishBlueprint={() => this.setState({ isPublish: true })}
            />
          </div>
        </div>
      </div>
    );
  }
}
